export const QUERY_KEYS = {
  COUNTRY_ADMIN: ["country-admin"],
  LANGUAGES: ["languages"],
  COUNTRIES: ["countries"],
  QUERY_KEY_STATIC_STRINGS: ["static-strings"],
  QUESTION: ["question"],
  HCP: ["hcp"],
  HOSPITAL: ["hospitals"],
  HOSPITAL_DETAILS: ["hospital-detail"],
  APP_VERSION: ["app-version"],
  COUNTRY: "COUNTRY",
  COUNTRY_LIST: ["country-list"],
  REQUEST:["requests"],
  REQUESTS: ["requests"]
};